import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function MeetingControl({contact,registrations,sessions,onChange,toggle=false}) {
  const [selectedId,setSelectedId]=useState('');
  const rows=registrations.filter(item=>item.contactId===contact.id);
  const selected=rows.find(item=>item.id===selectedId) || rows[0];
  const meeting=selected?.meeting || '未予約';
  return <span onClick={event=>event.stopPropagation()}>
    {rows.length>1 && <select className="inline-select" aria-label={`${contact.name}の商談対象の開催回`}
      value={selected.id} onChange={event=>setSelectedId(event.target.value)}>
      {rows.map(row=>{const session=sessions.find(item=>item.id===row.sessionId);return <option key={row.id} value={row.id}>
        {session ? new Date(session.date).toLocaleString('ja-JP',{timeZone:'Asia/Tokyo'}) : row.sessionId}（{row.sessionId}）
      </option>;})}
    </select>}
    {!selected ? <span className="muted-copy">申込履歴なし</span> : toggle
      ? <button className={meeting==='予約済み' ? 'secondary-button small' : 'primary-button small'}
        onClick={()=>onChange(selected.id,meeting==='予約済み' ? '未予約' : '予約済み')}>
        <SafeIcon icon={FiIcons.FiCalendar} />{meeting==='予約済み' ? '予約を解除' : '予約をテスト更新'}
      </button>
      : <select className="inline-select" aria-label={`${contact.name}の商談予約`}
        value={meeting} onChange={event=>onChange(selected.id,event.target.value)}>
        <option>未予約</option><option>予約済み</option>
      </select>}
  </span>;
}
